// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3E8zI","label":"SetPasswdForm_label__1ikj_"};